import { Album as DownloadAlbum } from '@bpm-web-app/download-api-sdk';
import { MediaWithAlbum } from '@bpm-web-app/stream-api-sdk';
import classNames from 'classnames';
import { DEFAULT_HOMEPAGE_TRACKLIST_LIMIT } from '@bpm-web-app/utils';
import { GhostComponent } from '../ghost-component/ghost-component';
import { SecondaryPageTitle } from '../secondary-page-title/secondary-page-title';
import { SeeMoreTracklistLink } from '../see-more-button/see-more-btn';
import { TrackListSupreme } from '../track-list/supreme/track-list-supreme';
import { TrackListPresetSupreme } from '../track-list/supreme/track-list-supreme-helpers';

export interface HomepageTracklistSectionProps {
    title: string;
    href: string;
    list?: DownloadAlbum[] | MediaWithAlbum[];
    preset: TrackListPresetSupreme;
    isLoading: boolean;
    trendingStatusToShow?: 'trending_status_weekly' | 'trending_status_daily' | 'trending_status_monthly';
}

/* Shared shape for the homepage's "New Music" / "Exclusives" / "Top 10" sections — same
 * title/tracklist/see-more layout, differing only in which data feeds it. */
export function HomepageTracklistSection({ title, href, list, preset, isLoading, trendingStatusToShow }: HomepageTracklistSectionProps) {
    if (isLoading) {
        return (
            <GhostComponent
                type="track-list"
                elementsCount={DEFAULT_HOMEPAGE_TRACKLIST_LIMIT}
                title={title}
                preset={preset}
            />
        );
    }

    if (!list || list.length === 0) return null;

    return (
        <div className="spacing--section-bottom">
            <SecondaryPageTitle title={title} />
            <div className={classNames('spacing__window--horizontal', 'spacing--top')}>
                <TrackListSupreme
                    preset={preset}
                    list={list}
                    isSortable={false}
                    trendingStatusToShow={trendingStatusToShow}
                />
                <SeeMoreTracklistLink href={href} expand={false} />
            </div>
        </div>
    );
}

export default HomepageTracklistSection;
